import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Select, MenuItem, TextField } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import { licenseeFetchList } from 'reducers/licensee/reducer'
import { setLicenseeContext } from 'reducers/profile/reducer'
import { fetchSites } from 'reducers/dashboard/reducer'
import Psfs from 'lib/psfs/Psfs'
import { API_URL_LICENSEE_LIST } from 'constants/index'
import withPromise from 'helpers/withPromise'
import messages from './translate'

class FilterLicensee extends Component {
  constructor(props) {
    super(props)
    this.state = {
      licensees: [],
      filteredLicensees: [],
      searchQuery: '',
    }
    this.searchInputRef = React.createRef()
  }

  componentDidMount() {
    withPromise(this.props.licenseeFetchList, {
      psfs: Psfs.create(API_URL_LICENSEE_LIST)
        .createPagination(1, 'all')
        .addFields(['id', 'name']),
    }).then(data => {
      this.setState({
        licensees: data,
        filteredLicensees: data,
      })
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { searchQuery: prevSearchQuery } = prevState
    const { searchQuery } = this.state

    if (prevSearchQuery !== searchQuery) {
      if (this.searchInputRef.current) {
        this.searchInputRef.current.focus()
      }
    }
  }

  onChangeLicensee = e => {
    const lisId = e.currentTarget.dataset.value
    const { setLicenseeContext } = this.props
    setLicenseeContext({ licenseeId: parseInt(lisId, 10) })
  }

  onChangeSearchField = ({ target: { value: targetValue } }) => {
    const { licensees } = this.state

    const filteredOptions = licensees.filter(
      ({ name }) => name.toLowerCase().indexOf(targetValue.toLowerCase()) >= 0,
    )

    this.setState({
      filteredLicensees: filteredOptions,
      searchQuery: targetValue,
    })
  }

  render() {
    const { licensees, filteredLicensees, searchQuery } = this.state
    const {
      intl: { formatMessage },
      licenseeId,
    } = this.props

    return (
      <div className="filter-licensee">
        <Select
          fullWidth
          disableUnderline
          value={licenseeId}
          onChange={this.onChangeLicensee}
          onOpen={() => {
            setTimeout(() => {
              if (this.searchInputRef.current) {
                this.searchInputRef.current.focus()
              }
            }, 0)
          }}
          onClose={() => {
            this.setState({
              searchQuery: '',
              filteredLicensees: licensees,
            })
          }}>
          <MenuItem
            style={{
              padding: '0',
              minHeight: '0',
            }}
            onKeyDown={event => {
              event.stopPropagation()
            }}
            button={false}>
            <TextField
              style={{
                padding: '8px',
              }}
              fullWidth
              placeholder={formatMessage(messages.search)}
              value={searchQuery}
              inputProps={{
                ref: this.searchInputRef,
              }}
              onClick={event => {
                event.stopPropagation()
              }}
              onChange={this.onChangeSearchField}
            />
          </MenuItem>
          {filteredLicensees.map(({ id, name }) => (
            <MenuItem button value={id} key={`licensee_key_${id}`}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </div>
    )
  }
}

export default connect(
  state => ({
    licenseeId: state.getIn(['profile', 'licenseeId']),
  }),
  {
    fetchSites,
    licenseeFetchList,
    setLicenseeContext,
  },
)(injectIntl(FilterLicensee))
